import LiveListingsMap from '../components/listings/LiveListingsMap'
import MlsDisclaimer from '../components/listings/MlsDisclaimer'
import Section from '../components/layout/Section'
import Reveal from '../components/layout/Reveal'
import Seo from '../components/seo/Seo'
import { useBreadcrumbs } from '../seo/useBreadcrumbs'

// B.2 — map-based listings browser ("like Leslie Savage's but better, on-theme").
// Dark CARTO basemap default, town quick-jump chips, OUR LISTINGS gold-star
// isolate (PART F feed), favorites/saved/compare, URL-synced filters.
export default function Listings() {
  const crumbs = useBreadcrumbs([{ label: 'Listings', path: '/listings' }])
  return (
    <Section id="listings-map" className="bg-neutral-charcoal pt-28 pb-16">
      <Seo
        title="Delaware Beach Homes for Sale — Live MLS Map | Merritt & Shawn | Coastal Delaware Real Estate"
        description="Browse every Bright MLS home for sale across Lewes, Rehoboth, Dewey, Bethany, Fenwick Island and Milton on a live interactive map — updated throughout the day."
        path="/listings"
        jsonLd={[crumbs.jsonLd]}
      />
      {crumbs.node}
      {/* Section header — kicker + thin/bold pair (B.2) */}
      <Reveal>
        <div className="mb-10">
          <p className="font-display text-[12px] uppercase tracking-[0.3em] font-medium text-white/70">
            Live at the Beaches
            <span className="block w-6 h-[2px] bg-accent-gold mt-3" aria-hidden="true" />
          </p>
          <h1 className="mt-4 font-display uppercase text-white leading-none text-[clamp(40px,6vw,84px)]">
            <span className="font-thin">Browse </span>
            <span className="font-bold">Listings</span>
          </h1>
          <p className="mt-4 max-w-2xl text-lg text-white/70 font-light leading-[1.9]">
            Every Bright MLS home for sale across the Delaware beaches — pan the
            map, jump to a town, or tap <span className="text-accent-gold">★ Our Listings</span> to
            see only Merritt & Shawn's own listings.
          </p>
        </div>
      </Reveal>

      <Reveal delay={120}>
        <LiveListingsMap />
      </Reveal>

      <MlsDisclaimer />
    </Section>
  )
}
